// extracted by mini-css-extract-plugin
export var active = "artOfAPerfectMealV2-module--active--2a6d0";
export var activeIngredientIndex = "artOfAPerfectMealV2-module--active-ingredient-index--a99a0";
export var arrow = "artOfAPerfectMealV2-module--arrow--8c6d7";
export var artOfAPerfectMealV2 = "artOfAPerfectMealV2-module--art-of-a-perfect-meal-v2--fb3cd";
export var content = "artOfAPerfectMealV2-module--content--c88e3";
export var detailsButton = "artOfAPerfectMealV2-module--details-button--45a08";
export var detailsContent = "artOfAPerfectMealV2-module--details-content--bc301";
export var fadeIn = "artOfAPerfectMealV2-module--fadeIn--6dd80";
export var headline = "artOfAPerfectMealV2-module--headline--9ec2c";
export var ingredient1 = "artOfAPerfectMealV2-module--ingredient-1--5a26c";
export var ingredient2 = "artOfAPerfectMealV2-module--ingredient-2--e6f53";
export var ingredient3 = "artOfAPerfectMealV2-module--ingredient-3--a19e3";
export var ingredient4 = "artOfAPerfectMealV2-module--ingredient-4--12df8";
export var ingredient5 = "artOfAPerfectMealV2-module--ingredient-5--0bef6";
export var ingredient6 = "artOfAPerfectMealV2-module--ingredient-6--e855d";
export var ingredientButton = "artOfAPerfectMealV2-module--ingredient-button--7533a";
export var ingredientDetails = "artOfAPerfectMealV2-module--ingredient-details--ce9f3";
export var ingredientDetailsWrapper = "artOfAPerfectMealV2-module--ingredient-details-wrapper--5f902";
export var mealImageWrapper = "artOfAPerfectMealV2-module--meal-image-wrapper--a9677";
export var nextButton = "artOfAPerfectMealV2-module--next-button--a1a65";
export var previousButton = "artOfAPerfectMealV2-module--previous-button--82d09";
export var retroIconsWrapper = "artOfAPerfectMealV2-module--retro-icons-wrapper--71bfa";
export var selectDisable = "artOfAPerfectMealV2-module--select-disable--3f141";
export var title = "artOfAPerfectMealV2-module--title--ca037";